@import '~style-sheet-helpers/core.less';
@import (reference) '~ss-ui-client/src/constants/spacing.module.less';
@import '~ss-ui-client/src/app-brand/entities/entity-layer.module.less';

.search-results {
  position: relative;

  .result-dropdown-menu {
    position: absolute;
    bottom: auto;
    top: 35px;
    //z-index prop has to be used because DropdownMenuItem is used outside the DropdownMenu component that usually provides z-index
    z-index: 2;
    left: 0;
    background-color: var(--white);
    border-radius: 4px;
    border: 1px solid var(--grey-300);
    max-height: 300px;
    overflow: auto;
    //width should match half of the shipping details form inputs minus half of shipping details form gap between them
    width: calc(50% - 16px);
    box-shadow: 3px 2px 2px var(--black-fade-20);
  }

  .row {
    white-space: normal;
  }

  .item-name {
    margin-bottom: @space-4;
    color: var(--grey-1000);
    line-height: 1.2;
  }

  .item-sku {
    color: var(--grey-700);
  }

  .item-name,
  .item-sku {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    width: 100%;
  }

  .result-item {
    border-bottom: 1px solid var(--grey-400);

    &:last-child {
      border-bottom: 0;
    }
  }

  .result-title {
    padding: @space-8;
    background-color: var(--blue-200);
  }
}
